import getApi from '../../api'
import {
  ErrorMessageContent,
  SendMessagePayload,
  SendMessageResponse,
} from '../../model/StatsAssistant'

export const sendMessage = (conversationUlid: string, payload: SendMessagePayload) =>
  getApi().post<SendMessageResponse, ErrorMessageContent>(
    `/stats_assistant/conversations/${conversationUlid}/messages`,
    payload,
  )
